<template>
  <header-banner-layout>
    <div v-if="hideMap" class="my-4">
      <group-header />
    </div>
    <map-banner v-else :map-center="mapCenter" :map-zoom="mapZoom">
      <template #content>
        <group-header />
      </template>
    </map-banner>
  </header-banner-layout>
</template>

<script>
import GroupHeader from '@/local-chapters/header'
import HeaderBannerLayout from '@/components/header-banner-layout'
import MapBanner from '@/components/map-banner'

export default {
  components: { GroupHeader, HeaderBannerLayout, MapBanner },

  props: {
    hideMap: {
      type: Boolean,
      required: false,
      default: false
    },
    mapCenter: {
      type: Object,
      required: true
    },
    mapZoom: {
      type: Number,
      required: false
    }
  }
}
</script>
